import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { AuthAccountState } from './auth-account.state';

@Injectable({providedIn: 'root'})
@StoreConfig({ name: 'authAccount', resettable: true, idKey: 'id' })
export class AuthAccountStore extends EntityStore<AuthAccountState> {
  constructor() {
    super();
  }
}
